import { useAppDispatch, useAppSelector } from "../../store/hooks";
import AlarmGroupUserAdderUI from "../ui/AlarmGroupUserAdderUI";
import { addAlarmGroupUsers } from "../../store/thunk/alarmGroup";
import { ParcialUser } from "../../types/apiv1";

interface AlarmGroupUserAdderProps {
	alarmGroupID: string;
	assignableUsers: ParcialUser[];
}

export default function AlarmGroupUserAdder(props: AlarmGroupUserAdderProps){
	const dispatch = useAppDispatch();
	const alarmGroupSession = useAppSelector(state => state.alarmGroup);

	function isPending(){
		return alarmGroupSession.kind === 'initializing';
	}

	async function onAdd(users: ParcialUser[]) {
		const assignableUsers = users.map( 
			user =>  
			({user_id: user.user_id})
		);
		console.log("Assignable Users: ", assignableUsers);
		dispatch(addAlarmGroupUsers(props.alarmGroupID, assignableUsers));
	}

	return <AlarmGroupUserAdderUI 
				loading={isPending()}
				onAdd={onAdd}
				assignableUsers={props.assignableUsers}
			/>
}
